<div class="splash-screen">
  <app-toast
    position="center"
    key="password-reset"
    data-qa="password-toast"
    >
    @if (customNotification === 'COMPROMISED') {
      <div>
        <p class="p-toast-detail">
          The password you have entered has appeared previously in a data breach of another site. Please select an
          alternative password.
        </p>
        <p class="p-toast-detail">You should consider changing this password anywhere else you have used it.</p>
        <a
          [routerLink]="['/login']"
          data-qa="compromised-try-again-link"
          >Try again later.</a
          >
        </div>
      }
      @if (customNotification === 'CHECK_FAILED') {
        <div>
          <p class="p-toast-detail">
            We were unable to verify the integrity of your password. Click "Continue" to retry now, or
            <a
              [routerLink]="['/login']"
              data-qa="check-failed-try-again-link"
              >
              try again later.
            </a>
          </p>
        </div>
      }
      @if (customNotification === 'SET_FAILED') {
        <div>
          <p class="p-toast-detail">
            Something went wrong when resetting your password. Please contact support, or
            <a
              [routerLink]="['/login']"
              data-qa="set-failed-try-again-link"
              >
              try again later.
            </a>
          </p>
        </div>
      }
      @if (customNotification === 'CODE_SEND_FAILED') {
        <div>
          <p class="p-toast-detail">
            Something went wrong when re-sending your code. Please contact support, or
            <a
              [routerLink]="['/login']"
              data-qa="code-send-try-again-link"
              >
              try again later.
            </a>
          </p>
        </div>
      }
    </app-toast>
    <div class="bx--grid">
      <div class="bx--row">
        <div class="bx--col-xlg-3 bx--col-lg-4 bx--col-md-4 bx--col-sm">
          <h1>Set a new password</h1>
          <form
            class="form-mt"
            [formGroup]="resetPasswordForm"
            >
            <div class="bx--form-item-control">
              <app-input-text
                data-qa="reset-password-username-input"
                inputId="login-username"
                label="Username"
                name="username"
                theme="dark"
                [errorText]="validateControl('username', 'Username')"
                [formGroup]="resetPasswordForm"
                [isDisabled]="!codeRequired"
              ></app-input-text>
            </div>
            @if (codeRequired) {
              <div
                class="bx--form-item-control"
                >
                <app-input-text
                  data-qa="reset-password-verification-code-input"
                  inputId="verificationcode-username"
                  label="Verification code"
                  name="code"
                  theme="dark"
                  [errorText]="validateControl('code', 'Code')"
                  [formGroup]="resetPasswordForm"
                ></app-input-text>
                <a
                  [routerLink]=""
                  (click)="resendCode()"
                  >Resend code</a
                  >
                </div>
              }
              <div class="bx--form-item-control">
                <app-input-text
                  autoComplete="new-password"
                  data-qa="reset-password-password-input"
                  inputId="resetpassword-password"
                  label="New password"
                  name="password"
                  theme="dark"
                  type="password"
                  [formGroup]="resetPasswordForm"
                ></app-input-text>
              </div>
              <div>
                @if (resetPasswordForm.controls.password.valid) {
                  <div>
                    <div class="message message-success">
                      <div class="message-content">
                        <strong data-qa="success-message-heading">
                          {{ heading }}
                        </strong>
                      </div>
                    </div>
                  </div>
                }
                @if (resetPasswordForm.controls.password.invalid) {
                  <div>
                    <div class="message message-error">
                      <div class="message-content">
                        <h4 data-qa="invalid-message-heading">{{ heading }}</h4>
                        <ul class="message-list">
                          <li class="password-requirement">
                            @if (!passwordHasMinimumCharacters()) {
                              <div>
                                <app-icon
                                  icon="misuse"
                                  class="icon icon-error"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            @if (passwordHasMinimumCharacters()) {
                              <div>
                                <app-icon
                                  icon="checkmark-filled"
                                  class="icon icon-success"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            <div>At least 10 characters; the more characters, the better.</div>
                          </li>
                          <li class="password-requirement">
                            @if (!passwordHasMixUpperAndLower()) {
                              <div>
                                <app-icon
                                  icon="misuse"
                                  class="icon icon-error"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            @if (passwordHasMixUpperAndLower()) {
                              <div>
                                <app-icon
                                  icon="checkmark-filled"
                                  class="icon icon-success"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            <div>A mixture of both uppercase and lowercase letters</div>
                          </li>
                          <li class="password-requirement">
                            @if (!passwordHasMixLetterAndNumbers()) {
                              <div>
                                <app-icon
                                  icon="misuse"
                                  class="icon icon-error"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            @if (passwordHasMixLetterAndNumbers()) {
                              <div>
                                <app-icon
                                  icon="checkmark-filled"
                                  class="icon icon-success"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            <div>A mixture of letters and numbers</div>
                          </li>
                          <li class="password-requirement">
                            @if (!passwordHasSpecialCharacters()) {
                              <div>
                                <app-icon
                                  icon="misuse"
                                  class="icon icon-error"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            @if (passwordHasSpecialCharacters()) {
                              <div>
                                <app-icon
                                  icon="checkmark-filled"
                                  class="icon icon-success"
                                  iconSize="24"
                                ></app-icon>
                              </div>
                            }
                            <div>Inclusion of at least one special character, e.g., ! &#64; # ? .</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <div class="bx--form-item-control">
                <app-input-text
                  autoComplete="new-password"
                  data-qa="reset-password-password-confirmation-input"
                  name="confirmPassword"
                  inputId="resetpassword-confirm-password"
                  label="Confirm password"
                  placeholder="Re-enter new password"
                  theme="dark"
                  type="password"
                  [formGroup]="resetPasswordForm"
                ></app-input-text>
              </div>
              <div class="bx--form-item-control">
                @if (!isProcessing) {
                  <app-button
                    data-qa="reset-password-submit-button"
                    [isDisabled]="isButtonDisabled()"
                    buttonLabel="Continue"
                    buttonIcon="pi pi-arrow-right"
                    (buttonClicked)="changePassword()"
                    type="submit"
                    buttonId="verify-submit"
                    class="full-width"
                  ></app-button>
                }
              </div>
              <div class="bx--form-item-control">
                @if (isProcessing) {
                  <img
                    data-qa="reset-password-loading-indicator"
                    class="spinner p-mt-2"
                    alt="spinning icon showing indicating form is loading"
                    src="../../../assets/images/spinner.svg"
                    />
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
